const authState = {
  loggedIn: false,
  phoneNumberLogin: null,
  loggedInUser: null,
  loggedInUserId: null,

};

const authActions = {
  setPhoneNumberLogin({ commit }, internationalPhoneNumber) {
    commit("setPhoneNumberLogin", internationalPhoneNumber);
  },
  async isPhoneNumberAlreadyExist({ commit }, phone) {
    let http = this._vm.$http;
    return http.get(`isphoneregistered/${phone}`).then(response => response.data);
  },
  async getGeoip({ commit }, all) {
    let http = this._vm.$http;
    let url = 'geoip';
    if (all) {
      url += '?data=all';
    }
    const response = await http.get(url);
    const countryCode = response.data.countryCode.toLocaleLowerCase();
    commit("setCountryCode", countryCode);
  },
  loggedInUser() {
    return this._vm.firebase.auth().currentUser;
  },
  loggedInUserId() {
    return this._vm.firebase.auth().currentUser.uid;
  },
  isLoggedIn() {
    return Boolean(this._vm.firebase.auth().currentUser);
  },
};

const authMutations = {
  setCountryCode(state, countryCode) {
    state.countryCode = countryCode;
  },
  setPhoneNumberLogin(store, internationalPhoneNumber) {
    store.phoneNumberLogin = internationalPhoneNumber;
  },
  setLoggedInUserId(state, id) {
    state.loggedInUserId = id;
  },
  setLoggedInUser({ commit }, user) {
    commit("setLoggedInUser", user);
  },
};


const authGetters = {
  isLoggedIn: state => state.loggedIn,
  getLoggedInUser: state => state.loggedInUser,
  getLoggedInUserId: state => state.loggedInUserId,
  getPhoneNumberLogin: state => state.phoneNumberLogin,
};

export {
  authActions,
  authGetters,
  authState,
  authMutations
};
